import axios from "axios";

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: null,
    },

    getters: {
        authenticated(state) {
            return state.authenticated;
        },

        user(state) {
            return state.user;
        },
    },

    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value;
        },

        SET_USER(state, value) {
            state.user = value;
        },
    },

    actions: {
        async checkIfUserRegistered({ dispatch }) {
            await axios.get("/sanctum/csrf-cookie").then(() => {
                return dispatch("me");
            });
        },

        async signIn({ dispatch }, credentials) {
            await axios.get("/sanctum/csrf-cookie");
            await axios.post("/login", credentials).then((resp) => {});

            return dispatch("me");
        },

        async registerNewUser({ dispatch }, userData) {
            await axios.post("/register", userData).then((resp) => {});
            return dispatch("me");
        },

        async sendResetLinkEmail({ dispatch }, email) {
            await axios.post("/password/email", email).then((response) => {});
        },

        async resetPassword({ dispatch }, newCredentials) {
            await axios
                .post("/password/reset", newCredentials)
                .then((response) => {});
            return dispatch("me");
        },

        async signOut({ dispatch }) {
            await axios.post("/logout");

            return dispatch("me");
        },

        async changePassword({ dispatch }, newCredentials) {
            await axios
                .post("/api/change-password", newCredentials)
                .then((response) => {});
        },
        async changeName({ dispatch }, payload) {
            await axios
                .post("/api/change-username", payload)
                .then((response) => {});
            dispatch("me");
        },

        async verifyEmail({ dispatch }, payload) {
            const { expires, signature } = payload;
            return axios
                .get(`/epasta/apstiprinasana/${payload.id}/${payload.hash}`, {
                    params: { expires, signature },
                })
                .then((response) => {});
        },

        me({ commit }) {
            return axios
                .get("/api/user")
                .then((response) => {
                    commit("SET_AUTHENTICATED", true);
                    commit("SET_USER", response.data);
                })
                .catch(() => {
                    commit("SET_AUTHENTICATED", false);
                    commit("SET_USER", null);
                });
        },
    },
};
